import React, { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  RELATIVE_VOLATILITY_BUCKETS,
  buildBucketPerformance,
  getTradeRelativeVolatility,
} from '../../lib/trades/dashboardBucketAnalytics';

interface PerformanceByRelativeVolatilityWidgetProps {
  timeRange: 'week' | 'month' | 'year';
  size: WidgetSize;
  trades?: any[];
}

export const PerformanceByRelativeVolatilityWidget: React.FC<PerformanceByRelativeVolatilityWidgetProps> = ({ 
  timeRange, 
  size,
  trades = [],
}) => {
  const perfData = useMemo(
    () => buildBucketPerformance({ trades, timeRange, buckets: RELATIVE_VOLATILITY_BUCKETS, metric: getTradeRelativeVolatility }),
    [timeRange, trades]
  );

  return <BucketPerformanceList result={perfData} size={size} pctFormatter={(item) => `${item.pct.toFixed(item.pnl === 0 ? 1 : 2)}%`} />;
};